export const AR = {
  header: "مشاريعنا",
  TITLE: "البعض من مشاريعنا",
  DIS: `الياسمين للأعمال الهندسية والتشطيبات والديكور . تأسس مكتبنا استجابه للحاجة الملحوظه في سوق العمل للمهندسين ذوى الخبرة في مجال التصميم الداخلي والديكور ولذلك نحن متمسكون بأعلي معايير الاحتراف والصدق والتفاني في عملنا ونؤمن ان هذه القيم تنعكس على تصميماتنا ذات الاسعار التنافسيه , فريق متكامل من المهندسين المبدعين يلتزمون بالمعايير الهندسيه 
              الانشائيه والمعماريه والاستخدام الأمثل للخامات بالتالي تحقيق التوازن
               بين الجوده والتكلفه , يلتزم مكتبنا بتزويد عملائنا بحلول تصميم داخلي مميزه مصممه خصيصا لتلبية احتياجاتهم وتفضيلاتهم الخاصة , هدفنا هو حمايه العميل من اي استغلال محتمل او ممارسات هواه. `,
};

export const USA = {
  header: "projects",
  TITLE: "Some of our projects",
  DIS: `Al-Yasmine for engineering, finishing and decoration works. An integrated team of creative
    engineers committed to structural and architectural engineering
    standards and the optimal use of materials, thus achieving a balance
    between quality and cost, Our office is committed to providing our
    clients with distinctive interior design solutions specifically
    designed to meet their needs and preferences. Our goal is to protect
    the client from any potential exploitation or amateur practices.`,
};
